import { Skeleton } from '@mui/material';

const CategoryCardSkeleton = () => (
  <Skeleton animation="wave" variant="rounded" width="100%" height={184} sx={{ borderRadius: '12px' }} />
);

export default CategoryCardSkeleton;
